import { aiServiceFetch } from "utils/aiServiceRequest";

export interface McpFlowInfo {
  clientName: string;
  redirectHost: string;
}

export type McpFlowAction = "allow" | "deny";

export function getMcpFlowInfo(flowId: string): Promise<McpFlowInfo> {
  return aiServiceFetch<McpFlowInfo>(
    `/oauth/flow/${encodeURIComponent(flowId)}`,
    { method: "GET" }
  );
}

export function completeMcpFlow(
  flowId: string,
  action: McpFlowAction
): Promise<{ redirectUrl: string }> {
  return aiServiceFetch<{ redirectUrl: string }>(
    `/oauth/flow/${encodeURIComponent(flowId)}/complete`,
    { method: "POST", body: { action } }
  );
}
